// @ vendors
import React from 'react';
import { JointHolderDecision }  from 'components/jointHolders/jointHoldersDecision';
import { isCountrySpain } from 'utilities/multiLanguageHelper';

class JointHolderDecisionDispatcher extends React.Component {
    render() {
        const { handleSave } = this.props;
        if (isCountrySpain()) {
            return <JointHolderDecision handleSave={handleSave} />;
        }

        return null;
    }
}

module.exports = JointHolderDecisionDispatcher;
